export const WORK_TYPES = [
  { value: "bug_fix", label: "Bug fix", icon: "🐞", iconName: "bug" },
  { value: "feature", label: "Feature", icon: "✨", iconName: "spark" },
  { value: "improvement", label: "Improvement", icon: "↑", iconName: "upward-arrow" },
  { value: "refactor", label: "Refactor", icon: "⧉", iconName: "connected-blocks" },
  { value: "migration", label: "Migration", icon: "⇄", iconName: "transfer" },
  { value: "security", label: "Security", icon: "🛡", iconName: "shield" },
  { value: "research", label: "Research", icon: "🔍", iconName: "magnifier" },
  { value: "documentation", label: "Documentation", icon: "📄", iconName: "document" },
];

export function workTypeMeta(value) {
  return WORK_TYPES.find((row) => row.value === value) || {
    value: "",
    label: "Needs a type",
    icon: "•",
    iconName: "needs-type",
  };
}

export const ROADMAP_SECTIONS = [
  { value: "now", label: "Current sprint" },
  { value: "next", label: "Up next" },
  { value: "later", label: "Later" },
];
